import { getAllSupportTranslationCountryList } from '../country';
export var NameInDifferentCountriesEnum;

(function (NameInDifferentCountriesEnum) {
  NameInDifferentCountriesEnum["limitedCompany"] = "limitedCompany";
  NameInDifferentCountriesEnum["companyRegistrationNumber"] = "companyRegistrationNumber";
  NameInDifferentCountriesEnum["soleTrader"] = "soleTrader";
  NameInDifferentCountriesEnum["limitedLiabilityPartnership"] = "limitedLiabilityPartnership";
  NameInDifferentCountriesEnum["paye"] = "paye";
  NameInDifferentCountriesEnum["recruitmentAgency"] = "recruitmentAgency";
  NameInDifferentCountriesEnum["umbrellaCompany"] = "umbrellaCompany";
  NameInDifferentCountriesEnum["payrollCompany"] = "payrollCompany";
  NameInDifferentCountriesEnum["permanentWorker"] = "permanentWorker";
  NameInDifferentCountriesEnum["temporaryOrContractor"] = "temporaryOrContractor";
  NameInDifferentCountriesEnum["employerReferenceNumber"] = "employerReferenceNumber";
})(NameInDifferentCountriesEnum || (NameInDifferentCountriesEnum = {}));

var getExampleMap = function getExampleMap(country) {
  var nameMap = {
    ES: '',
    IS: '',
    BG: '',
    RO: '',
    HU: '',
    CY: '',
    SL: '',
    GR: '',
    SK: '',
    IT: '',
    EE: '',
    SE: '',
    CZ: '',
    LU: '',
    PL: '',
    FR: '',
    AT: '',
    BE: '',
    PT: '',
    LI: '',
    IE: '',
    DK: '',
    NL: '',
    NO: '',
    LT: '',
    HR: '',
    MT: '',
    LV: '',
    FI: '',
    DE: ''
  };
  return nameMap[country] || '';
};

var getLimitedCompanyDifferentCountryNameText = function getLimitedCompanyDifferentCountryNameText(country, config) {
  var nameMap = {
    ES: 'Sociedad Limitada, S.L., S.L.U.',
    IS: 'Einkahlutafélag, ehf.',
    BG: 'Дружество с ограничена отговорност, ООД (OOD), ЕООД (EOOD)',
    RO: 'SRL Societate Cu raspundere limitata',
    HU: 'Korlátolt felelősségű társaság (Kft.)',
    CY: 'Εταιρεία Περιορισμένης Ευθύνης, Ε.Π.Ε. (E.P.E.)',
    SL: 'Družba z omejeno odgovornostjo, d.o.o.',
    GR: 'Εταιρεία Περιορισμένης Ευθύνης, Ε.Π.Ε. (E.P.E.)',
    SK: 'Spoločnosť s ručením obmedzeným, s.r.o.',
    IT: 'Società a responsabilità limitata, S.r.l.',
    EE: 'Osaühing (OÜ)',
    SE: 'Aktiebolag, AB',
    CZ: 'Společnost s ručením omezeným, s.r.o.',
    LU: 'Société à responsabilité limitée, SARL',
    PL: 'Spółka z ograniczoną odpowiedzialnością, sp. z o.o.',
    FR: 'Société à responsabilité limitée, SARL',
    AT: 'Gesellschaft mit beschränkter Haftung, GmbH',
    BE: 'Société à responsabilité limitée, SARL',
    PT: 'Sociedade por Quotas',
    LI: 'Gesellschaft mit beschränkter Haftung, GmbH',
    IE: 'Limited company, Ltd',
    DK: 'Anpartsselskab, ApS',
    NL: 'Besloten vennootschap, BV',
    NO: 'Aksjeselskap, AS',
    LT: 'Uždaroji akcinė bendrovė, UAB',
    HR: 'Društvo s ograničenom odgovornošću, d.o.o.',
    MT: 'Private Limited Liability Company (Ltd)',
    LV: 'Sabiedrība ar ierobežotu atbildību, SIA',
    FI: 'Osakeyhtiö, Oy; Aktiebolag, Ab',
    DE: 'Gesellschaft mit beschränkter Haftung, GmbH'
  };
  return nameMap[country] || (config === null || config === void 0 ? void 0 : config.defaultText) || 'Limited company';
};

var getCompanyRegistrationNumberDifferentCountryNameText = function getCompanyRegistrationNumberDifferentCountryNameText(country) {
  var nameMap = {
    ES: 'Número de Identificación Fiscal (NIF) / Número de Identificación de la Sociedad (CIF)',
    IS: 'Kennitala',
    BG: 'Единен идентификационен код (ЕИК)',
    RO: 'Număr de Înregistrare la Registrul Comerțului (Nr. Reg. Com.) / Cod Unic de Înregistrare (CUI)',
    HU: 'Cégjegyzékszám ',
    CY: 'Αριθμός Γενικού Εμπορικού Μητρώου (Γ.Ε.ΜΗ.)',
    SL: 'Matična številka podjetja / Poslovni register Slovenije (PRS) številka',
    GR: 'Αριθμός Γενικού Εμπορικού Μητρώου (Γ.Ε.ΜΗ.)',
    SK: 'IČO (Identifikačné číslo organizácie)',
    IT: 'Numero di Iscrizione al Registro delle Imprese / Codice Fiscale',
    EE: 'Registrikood',
    SE: 'Organisationsnummer',
    CZ: 'Identifikační číslo osoby (IČO)',
    LU: "Num\xE9ro d'immatriculation au Registre de Commerce\xA0/\xA0Num\xE9ro RCS",
    PL: 'Numer KRS (Krajowy Rejestr Sądowy) / REGON',
    FR: "Num\xE9ro d'immatriculation au Registre de Commerce\xA0/\xA0Num\xE9ro RCS",
    AT: 'Firmenbuchnummer',
    BE: 'Bedrijfsregistratienummer',
    PT: 'Número de registo da empresa',
    LI: 'Firmenbuchnummer',
    IE: 'Company Registration Number (CRN)',
    DK: 'CVR-nummer (Det Centrale Virksomhedsregister)',
    NL: 'Registratie nummer Kamer van Koophandel (KvK-nummer)',
    NO: 'Organisasjonsnummer',
    LT: 'Juridinio asmens kodas',
    HR: 'Matični broj subjekta trgovačkog suda (MBS)',
    MT: 'Organisasjonsnummer',
    LV: 'Uzņēmuma reģistrācijas numurs',
    FI: 'Y-tunnus / Företagsnummer',
    DE: 'Handelsregisternummer / HRB-Nummer'
  };
  return nameMap[country] || 'Company Registration Number';
};

var getSoleTraderDifferentCountryNameText = function getSoleTraderDifferentCountryNameText(country) {
  var nameMap = {
    ES: 'Empresario Individual',
    IS: 'Einstaklingsfyrirtæki',
    BG: 'Едноличен търговец (ET)',
    RO: 'Persoană Fizică Autorizată (PFA)',
    HU: 'Egyéni vállalkozó',
    CY: 'Ατομική επιχείρηση ',
    SL: 'Samostojni podjetnik (s.p.)',
    GR: 'Ατομική επιχείρηση ',
    SK: 'Živnostník',
    IT: 'Impresa Individuale',
    EE: 'Füüsilisest isikust ettevõtja (FIE)',
    SE: 'Enskild firma',
    CZ: 'Osoba samostatně výdělečně činná (OSVČ)',
    LU: 'Entrepreneur individuel (EI)',
    PL: 'Jednoosobowa działalność gospodarcza" (JDG)',
    FR: 'Entrepreneur individuel (EI)',
    AT: 'Einzelunternehmen',
    BE: 'Entrepreneur individuel (EI)',
    PT: 'Empresário em Nome Individual',
    LI: 'Einzelunternehmen',
    IE: 'Sole Trader',
    DK: 'Enkeltmandsvirksomhed',
    NL: 'Eenmanszaak',
    NO: 'Enkeltpersonforetak',
    LT: 'Individuali veikla / Individuali įmonė',
    HR: 'Obrt / Samostalni poduzetnik',
    MT: 'Sole Proprietorship',
    LV: 'Individuālais komersants (IK)',
    FI: 'Yksityisyrittäjä',
    DE: 'Einzelunternehmen'
  };
  return nameMap[country] || 'Sole Trader';
};

var getLimitedLiabilityPartnershipDifferentCountryNameText = function getLimitedLiabilityPartnershipDifferentCountryNameText(country, config) {
  var nameMap = {
    ES: 'Sociedad Limitada Nueva Empresa (SLNE) / Sociedad Civil Profesional (SCP) / Sociedad Colectiva',
    IS: 'Sameignarfélag með takmarkaðri ábyrgð (slf.)',
    BG: 'Командитно дружество" (КД) or "КДООД',
    RO: 'Societate Civila Profesionala Cu raspundere limitata',
    HU: 'Betéti társaság (Bt.) / Korlátolt felelősségű társaság (Kft.)',
    CY: 'Εταιρεία Περιορισμένης Ευθύνης (Ε.Π.Ε.) / Ετερόρρυθμη Εταιρεία (Ε.Ε.)',
    SL: 'Komanditna družba (k.d.)',
    GR: 'Εταιρεία Περιορισμένης Ευθύνης (Ε.Π.Ε.) / Ετερόρρυθμη Εταιρεία (Ε.Ε.)',
    SK: 'Živnostník',
    IT: 'Società in accomandita semplice (S.a.s.) / Società in accomandita per azioni (S.a.p.a.)',
    EE: 'Usaldusühing (UÜ) / Täisühing (TÜ)',
    SE: 'Kommanditbolag (KB)',
    CZ: 'Komanditní společnost (k.s.)',
    LU: 'Société en commandite simple (SCS)',
    PL: 'Spółka komandytowa (Sp.k.) / Spółka komandytowo-akcyjna (S.K.A.)',
    FR: 'Société en commandite simple (SCS)',
    AT: 'Kommanditgesellschaft',
    BE: 'Société en commandite simple (SCS)',
    PT: 'Sociedade Anónima',
    LI: 'Kommanditgesellschaft',
    IE: 'Limited Liability Partnership',
    DK: 'Enkeltmandsvirksomhed',
    NL: 'VoF/Maatschap',
    NO: 'Enkeltpersonforetak',
    LT: 'Individuali veikla / Individuali įmonė',
    HR: 'Obrt / Samostalni poduzetnik',
    MT: 'Partnerships (General and Limited)',
    LV: 'SIA',
    FI: 'Rajoitetun vastuun kumppanuus',
    DE: 'Kommanditgesellschaft'
  };
  return nameMap[country] || (config === null || config === void 0 ? void 0 : config.defaultText) || 'Limited Liability Partnership';
};

var getPAYEDifferentCountryNameText = function getPAYEDifferentCountryNameText(country) {
  var nameMap = {
    ES: 'Trabajador de empresa de gestión para autónomos, Trabajador de empresa paraguas',
    IS: 'Starfsmaður umbrelufyrirtækis / Launaþjónustufyrirtæki',
    BG: 'Служител на фирма за управление на трудови правоотношения',
    RO: 'Angajat al unei companii de tip „umbrella” sau',
    HU: 'Munkáltatói adólevonás / Személyi jövedelemadó (SZJA) levonás',
    CY: 'Μισθοδοσία με παρακράτηση φόρου από τον εργοδότη',
    SL: 'Zaposlen pri "umbrella podjetju"',
    GR: 'Υπάλληλος εταιρείας διαχείρισης συμβάσεων',
    SK: 'Zamestnanec spoločnosti na správu zamestnancov',
    IT: 'Dipendente di una società di gestione contratti',
    EE: 'Töötaja töövõtulepingu haldava ettevõtte kaudu',
    SE: 'Konsult anställd av bemanningsföretag eller lönebolag',
    CZ: 'Zaměstnanec přes agenturu práce',
    LU: 'Salarié d’une société parapluie',
    PL: 'Pracownik firmy parasolowej',
    FR: 'Salarié d’une société parapluie',
    AT: 'Arbeitnehmer einer Gehaltsabrechnungsfirma / Arbeitgebermodell',
    BE: 'Werknemer van een payrollbedrijf',
    PT: 'Trabalhador através de empresa de portagem salarial',
    LI: 'Arbeitnehmer einer Lohnverrechnungsfirma / Vermittlungsfirma',
    IE: 'PAYE',
    DK: 'Ansat i lønselskab eller umbrella-virksomhed',
    NL: 'Werknemer van payrollbedrijf of uitzendbureau',
    NO: 'Ansatt i lønnsselskap eller umbrella-selskap',
    LT: 'Skėtinės įmonės darbuotojas',
    HR: 'Zaposlenik kišobran tvrtke',
    MT: 'Worker engaged via payroll service company / umbrella company',
    LV: 'Jumta uzņēmuma darbinieks',
    FI: 'Työntekijä palkanlaskentayrityksen kautta',
    DE: 'Arbeitnehmer einer Gehaltsabrechnungsfirma / Arbeitgebermodell'
  };
  return nameMap[country] || 'PAYE';
};

var getRecruitmentAgencyDifferentCountryNameText = function getRecruitmentAgencyDifferentCountryNameText(country) {
  var nameMap = {
    ES: 'Agencia de Reclutamiento',
    IS: 'Ráðningastofa',
    BG: 'Агенция за подбор на персонал',
    RO: 'Agenție de recrutare',
    HU: 'Munkaerő-közvetítő ügynökség',
    CY: 'Ιδιωτικό Γραφείο Ευρέσεως Εργασίας (ΙΓΕΕ)',
    SL: 'Agencija za zaposlovanje',
    GR: 'Ιδιωτικό Γραφείο Ευρέσεως Εργασίας (ΙΓΕΕ)',
    SK: 'Personálna agentúra',
    IT: 'Agenzia per il lavoro / Agenzia di collocamento',
    EE: 'Värbamisbüroo',
    SE: 'Rekryteringsbyrå',
    CZ: 'Personální agentura',
    LU: 'Agence de recrutement',
    PL: 'Agencja zatrudnienia',
    FR: 'Agence de recrutement',
    AT: 'Personalvermittlungsagentur',
    BE: 'Uitzendbureau',
    PT: 'Agência de recrutamento',
    LI: 'Personalvermittlungsagentur',
    IE: 'Recruitment Agency',
    DK: 'Rekrutteringsbureau',
    NL: 'Uitzendbureau',
    NO: 'Rekrutteringsbyrå',
    LT: 'Darbo agentūra',
    HR: 'Agencija za zapošljavanje',
    MT: "A\u0121enzija ta' Rekrutament, Recruitment Agency",
    LV: 'Personāla atlases aģentūra',
    FI: 'Rekrytointitoimisto',
    DE: 'Personalvermittlungsagentur'
  };
  return nameMap[country] || 'Recruitment Agency';
};

var getUmbrellaCompanyDifferentCountryNameText = function getUmbrellaCompanyDifferentCountryNameText(country) {
  var nameMap = {
    ES: 'Empresa paraguas',
    IS: 'Umbrella-fyrirtæki',
    BG: 'Управляваща компания',
    RO: 'Societate „umbrelă”',
    HU: 'Umbrella cég',
    CY: 'Ενδιάμεση Εταιρεία / Εταιρεία Ομπρέλα',
    SL: '“Dežnik podjetje” / Posredniško podjetje',
    GR: 'Ενδιάμεση Εταιρεία / Εταιρεία Ομπρέλα',
    SK: 'Personálna agentúra',
    IT: 'Società "ombrello" / Società intermedia',
    EE: 'Umbrella-ettevõte / Vahendusettevõte',
    SE: 'Egenanställningsföretag',
    CZ: 'Umbrella společnost / Zprostředkovatelská společnost',
    LU: 'Société de portage salarial',
    PL: 'Firma parasolowa',
    FR: 'Société de portage salarial ',
    AT: 'Dachgesellschaft',
    BE: 'Overkoepelende onderneming',
    PT: 'Empresa guarda-chuva',
    LI: 'Dachgesellschaft',
    IE: 'Umbrella Company',
    DK: 'Paraplyvirksomhed',
    NL: 'Payrollbedrijf',
    NO: 'Paraplyselskap',
    LT: 'Darbo agentūra',
    HR: 'Agencija za zapošljavanje',
    MT: "A\u0121enzija ta' Rekrutament, Recruitment Agency",
    LV: 'Personāla aģentūra',
    FI: 'Kattoyhtiö',
    DE: 'Dachgesellschaft'
  };
  return nameMap[country] || 'Umbrella Company';
};

var getPayrollCompanyDifferentCountryNameText = function getPayrollCompanyDifferentCountryNameText(country) {
  var nameMap = {
    ES: 'Empresa de nómina, Compañía de nóminas',
    IS: 'Launakeyrslufyrirtæki, Launakeyrsluhópur',
    BG: 'Компания за обработка на заплати',
    RO: 'Companie de administrare a salariilor',
    HU: 'Bérszámfejtő cég',
    CY: 'Εταιρεία Διαχείρισης Μισθοδοσίας',
    SL: 'Družba za obračun plač',
    GR: 'Εταιρεία Διαχείρισης Μισθοδοσίας',
    SK: 'Mzdová spoločnosť, Spoločnosť pre spracovanie miezd',
    IT: 'Società di elaborazione paghe / Società di gestione paghe',
    EE: 'Palgafirma, Palgaarvestusettevõte',
    SE: 'Löneadministrationsföretag / Lönebyrå',
    CZ: 'Mzdová účetní společnost ',
    LU: 'Société de gestion de la paie, Société de payroll',
    PL: 'Firma płacowa, Firma do obsługi płac',
    FR: 'Société de gestion de la paie, Société de payroll',
    AT: 'Lohnverrechnungsfirma, Payroll-Unternehmen',
    BE: 'Salarisadministratiebedrijf',
    PT: 'Empresa de folha de pagamento',
    LI: 'Lohnverrechnungsfirma, Payroll-Unternehmen',
    IE: 'Payroll Company',
    DK: 'Lønselskab, Payroll virksomhed',
    NL: 'Payrollbedrijf',
    NO: 'Lønnsselskap, Payroll selskap',
    LT: 'Atlyginimų apskaitos įmonė, Darbo užmokesčio įmonė',
    HR: 'Tvrtka za obračun plaća, Plaćarska tvrtka',
    MT: 'Kumpanija tal-pagi, Payroll Company',
    LV: 'Algu aprēķināšanas uzņēmums',
    FI: 'Palkkahallintoyhtiö',
    DE: 'Lohnabrechnungsfirma, Payroll-Unternehmen'
  };
  return nameMap[country] || 'Payroll Company';
};

var getPermanentWorkerDifferentCountryNameText = function getPermanentWorkerDifferentCountryNameText(country) {
  var nameMap = {
    ES: 'Trabajador fijo, Trabajador permanente',
    IS: 'Fastráðinn starfsmaður',
    BG: 'Постоянен работник ',
    RO: 'Angajat permanent',
    HU: 'Állandó munkavállaló',
    CY: 'Μόνιμος εργαζόμενος ',
    SL: 'Stalno zaposleni delavec',
    GR: 'Μόνιμος εργαζόμενος ',
    SK: 'Stály pracovník',
    IT: 'Lavoratore permanente',
    EE: 'Püsitöötaja',
    SE: 'Fast anställd, Tillsvidareanställd',
    CZ: 'Stálý pracovník',
    LU: 'Salarié en CDI ',
    PL: 'Pracownik zatrudniony na czas nieokreślony',
    FR: 'Salarié en CDI ',
    AT: 'Festangestellter',
    BE: 'Vaste werknemer ',
    PT: 'Trabalhador permanente',
    LI: 'Festangestellter',
    IE: 'Permanent worker',
    DK: 'Fastansat medarbejder',
    NL: 'Vaste werknemer',
    NO: 'Fast ansatt',
    LT: 'Nuolatinis darbuotojas',
    HR: 'Stalni radnik',
    MT: 'Fast ansatt',
    LV: 'Pastāvīgais darbinieks',
    FI: 'Pysyvä työntekijä',
    DE: 'Festangestellter'
  };
  return nameMap[country] || 'Permanent worker';
};

var getTemporaryOrContractorDifferentCountryNameText = function getTemporaryOrContractorDifferentCountryNameText(country) {
  var nameMap = {
    ES: 'Trabajador temporal',
    IS: 'Tímabundinn starfsmaður',
    BG: 'Временен работник',
    RO: 'Lucrător temporar',
    HU: 'Ideiglenes munkavállaló',
    CY: 'Προσωρινός εργαζόμενος',
    SL: 'Začasni delavec',
    GR: 'Προσωρινός εργαζόμενος',
    SK: 'Dočasný pracovník',
    IT: 'Lavoratore temporaneo',
    EE: 'Ajutine töötaja',
    SE: 'Visstidsanställd / Konsult / Entreprenör',
    CZ: 'Agenturní zaměstnanec / OSVČ',
    LU: 'Travailleur temporaire/ Travailleur indépendant',
    PL: 'Pracownik tymczasowy',
    FR: 'Travailleur temporaire/ Travailleur indépendant',
    AT: 'Zeitarbeiter',
    BE: 'Tijdelijke werknemer',
    PT: 'Trabalhador temporário',
    LI: 'Zeitarbeiter',
    IE: 'Temporary worker',
    DK: 'Vikar/kontraktansat',
    NL: "Tijdelijke werknemer/zzp'er",
    NO: 'Midlertidig ansatt',
    LT: 'Laikinas darbuotojas',
    HR: 'Privremeni radnik',
    MT: 'Vikar/entreprenør',
    LV: 'Pagaidu darbinieks',
    FI: 'Määräaikainen työntekijä/urakoitsija',
    DE: 'Zeitarbeiter'
  };
  return nameMap[country] || 'Temporary/Contractor';
};

var getEmployerReferenceNumberDifferentCountryNameText = function getEmployerReferenceNumberDifferentCountryNameText(country) {
  var nameMap = {
    ES: 'Código de empresa',
    IS: 'Kennitala vinnuveitanda',
    BG: 'Референтен номер на работодателя',
    RO: 'Număr de referință al angajatorului',
    HU: 'Munkáltatói azonosító szám / Munkaadó regisztrációs száma',
    CY: 'Αριθμός Μητρώου Εργοδότη (ΑΜΕ)',
    SL: 'Referenčna številka delodajalca',
    GR: 'Αριθμός Μητρώου Εργοδότη (ΑΜΕ)',
    SK: 'Referenčné číslo zamestnávateľa',
    IT: 'Numero di riferimento del datore di lavoro, Codice datore di lavoro',
    EE: 'Tööandja registrikood',
    SE: 'Arbetsgivarnummer ',
    CZ: 'Identifikační číslo zaměstnavatele / IČO',
    LU: 'Numéro de référence employeur',
    PL: 'Numer referencyjny pracodawcy',
    FR: 'Numéro de référence employeur',
    AT: 'Arbeitgebernummer, Dienstgebernummer',
    BE: 'Werkgeversreferentienummer',
    PT: 'Número de referência do empregador',
    LI: 'Arbeitgebernummer, Dienstgebernummer',
    IE: 'Employer reference number',
    DK: 'Arbejdsgiver referencenummer',
    NL: 'Loonbelastingnummer',
    NO: 'Arbeidsgiverreferansenummer',
    LT: 'Darbdavio nuorodos numeris',
    HR: 'Referentni broj poslodavca',
    MT: 'Arbeidsgiverreferansenummer',
    LV: 'Darba devēja reģistrācijas numurs',
    FI: 'Työnantajan viitenumero',
    DE: 'Arbeitgebernummer, Betriebsnummer'
  };
  return nameMap[country] || 'Employer Reference Number';
};

export var getTheNameTextInDifferentCountries = function getTheNameTextInDifferentCountries(nameEnum, country, config) {
  switch (nameEnum) {
    case NameInDifferentCountriesEnum.limitedCompany:
      return getLimitedCompanyDifferentCountryNameText(country, config);

    case NameInDifferentCountriesEnum.companyRegistrationNumber:
      return getCompanyRegistrationNumberDifferentCountryNameText(country);

    case NameInDifferentCountriesEnum.soleTrader:
      return getSoleTraderDifferentCountryNameText(country);

    case NameInDifferentCountriesEnum.limitedLiabilityPartnership:
      return getLimitedLiabilityPartnershipDifferentCountryNameText(country, config);

    case NameInDifferentCountriesEnum.paye:
      return getPAYEDifferentCountryNameText(country);

    case NameInDifferentCountriesEnum.recruitmentAgency:
      return getRecruitmentAgencyDifferentCountryNameText(country);

    case NameInDifferentCountriesEnum.umbrellaCompany:
      return getUmbrellaCompanyDifferentCountryNameText(country);

    case NameInDifferentCountriesEnum.payrollCompany:
      return getPayrollCompanyDifferentCountryNameText(country);

    case NameInDifferentCountriesEnum.permanentWorker:
      return getPermanentWorkerDifferentCountryNameText(country);

    case NameInDifferentCountriesEnum.temporaryOrContractor:
      return getTemporaryOrContractorDifferentCountryNameText(country);

    case NameInDifferentCountriesEnum.employerReferenceNumber:
      return getEmployerReferenceNumberDifferentCountryNameText(country);

    default:
      return '';
  }
};
export var getTheNameTextInDifferentCountriesWithProjectLocale = function getTheNameTextInDifferentCountriesWithProjectLocale(nameEnum, locale) {
  var _getAllSupportTransla;

  return getTheNameTextInDifferentCountries(nameEnum, (_getAllSupportTransla = getAllSupportTranslationCountryList().find(function (item) {
    return item.locale === locale;
  })) === null || _getAllSupportTransla === void 0 ? void 0 : _getAllSupportTransla.countryCode);
};